export default "__VITE_ASSET__b0b76231__"